/* tslint:disable:max-line-length semicolon *//*
 * (c) Copyright 2018 e5 Workflow
 *
 * Angular models generated 2/6/2019, 5:37:18 PM.
    */
  export class ContentStorageContractsDataContractsContent {
// {"format":"byte","type":"string"}
    blob: string | undefined
// {"type":"string"}
    blobUri: string | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.ContentClass"}
    contentClass: any | undefined
// {"format":"int32","type":"integer"}
    contentClassId: number | undefined
// {"type":"string"}
    contentExtension: string | undefined
// {"type":"string"}
    contentType: string | undefined
// {"format":"date-time","type":"string"}
    createdDateTime: string | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"items":{"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.Metadata"},"type":"array"}
    metadata: ContentStorageContractsDataContractsMetadata[] | undefined ; 
// {"type":"string"}
    objectId: string | undefined
// {"items":{"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.ContentViolation"},"type":"array"}
    violations: ContentStorageContractsDataContractsContentViolation[] | undefined ; 
  }

  export class ContentStorageContractsDataContractsContentClass {
// {"format":"date-time","type":"string"}
    creationDateTime: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.StorageLocation"}
    primaryStorageLocation: any | undefined
// {"format":"int32","type":"integer"}
    primaryStorageLocationId: number | undefined
// {"format":"int32","type":"integer"}
    retentionPeriod: number | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.StorageLocation"}
    secondaryStorageLocation: any | undefined
// {"format":"int32","type":"integer"}
    secondaryStorageLocationId: number | undefined
// {"format":"int32","type":"integer"}
    statusId: number | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.StoragePolicy"}
    storagePolicy: any | undefined
// {"format":"date-time","type":"string"}
    updatedDateTime: string | undefined
// {"items":{"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.ContentClassViolation"},"type":"array"}
    violations: ContentStorageContractsDataContractsContentClassViolation[] | undefined ; 
  }

  export class ContentStorageContractsDataContractsContentClassViolation {
// {"type":"string"}
    message: string | undefined
  }

  export class ContentStorageContractsDataContractsContentViolation {
// {"type":"string"}
    message: string | undefined
  }

  export class ContentStorageContractsDataContractsFilterComparisonModel {
// {"type":"string"}
    field: string | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.FilterModel"}
    filter: any | undefined
// {"type":"string"}
    operator: string | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class ContentStorageContractsDataContractsFilterModel {
// {"items":{"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.FilterComparisonModel"},"type":"array"}
    filters: ContentStorageContractsDataContractsFilterComparisonModel[] | undefined ; 
// {"type":"string"}
    logic: string | undefined
  }

  export class ContentStorageContractsDataContractsMetadata {
// {"type":"string"}
    name: string | undefined
// {"enum":["MetadataAdded","MetadataDeleted","MetadataUpdated","Unchanged"],"type":"string"}
    state: string | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class ContentStorageContractsDataContractsSearchCriteria {
// {"format":"int32","type":"integer"}
    contentClassId: number | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.SearchSelectFields"}
    fields: any | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.FilterModel"}
    filter: any | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.SearchOrderBy"}
    orderBy: any | undefined
// {"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.SearchPageInfo"}
    pageInfo: any | undefined
  }

  export class ContentStorageContractsDataContractsSearchOrderBy {
// {"items":{"$ref":"#/definitions/System.Collections.Generic.KeyValuePair`2[[System.String, mscorlib, Version=4.0.0.0, Culture=neutral, PublicKeyToken=b77a5c561934e089],[e5.ContentStorage.Contracts.DataContracts.SearchOrderBy+OrderByClauseEnum, e5.ContentStorage.Contracts, Version=3.0.0.0, Culture=neutral, PublicKeyToken=aaeabfa7a8a0bb34]]"},"type":"array"}
    fields: any[] | undefined ; 
  }

  export class ContentStorageContractsDataContractsSearchPageInfo {
// {"format":"int32","type":"integer"}
    pageIndex: number | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
  }

  export class ContentStorageContractsDataContractsSearchResult {
// {"items":{"$ref":"#/definitions/e5.ContentStorage.Contracts.DataContracts.Content"},"type":"array"}
    contents: ContentStorageContractsDataContractsContent[] | undefined ; 
// {"format":"int32","type":"integer"}
    totalCount: number | undefined
  }

  export class ContentStorageContractsDataContractsSearchSelectFields {
// {"items":{"type":"string"},"type":"array"}
    fields: string[] | undefined ; 
  }

  export class ContentStorageContractsDataContractsStorageLocation {
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string | undefined
// {"additionalProperties":{"type":"string"},"type":"object"}
    settings: any | undefined
// {"enum":["AmazonS3","AzureBlobStorage","AzureTableStorage","CustomProvider","EMCATMOS","HPCloudObjectStorage","InMemory","LocalVolume","MongoDBGridFS","SharePoint"],"type":"string"}
    storageType: string | undefined
// {"type":"boolean"}
    supportsMetadata: boolean | undefined
// {"type":"boolean"}
    useAsPrimaryMetadataStore: boolean | undefined
  }

  export class ContentStorageContractsDataContractsStoragePolicy {
  }

  export class AssemblyClassModel {
// {"type":"string"}
    assemblyName: string | undefined
// {"type":"string"}
    className: string | undefined
  }

  export class AssemblyDefinitionModel {
// {"type":"string"}
    assemblyName: string | undefined
// {"type":"string"}
    className: string | undefined
// {"type":"string"}
    methodName: string | undefined
  }

  export class AuthenticationDefinitionModel {
// {"enum":["Basic","Forms","UseDefaultCredentials","WindowsIntegrated"],"type":"string"}
    authType: string | undefined
// {"type":"string"}
    domain: string | undefined
// {"type":"string"}
    password: string | undefined
// {"type":"string"}
    username: string | undefined
  }

  export class LengthDefinitionModel {
// {"enum":["Percent","Pixels","Points"],"type":"string"}
    unit: string | undefined
// {"format":"double","type":"number"}
    value: number | undefined
  }

  export class ClaimModel {
// {"type":"string"}
    issuer: string | undefined
// {"additionalProperties":{"type":"string"},"type":"object"}
    properties: any | undefined
// {"type":"string"}
    type: string | undefined
// {"type":"string"}
    value: string | undefined
// {"type":"string"}
    valueType: string | undefined
  }

  export class ConfigurationInstanceModel {
// {"format":"int32","type":"integer"}
    activeArchiveLibraryId: number | undefined
// {"format":"int32","type":"integer"}
    activeWorkArchiveRepositoryId: number | undefined
// {"type":"string"}
    asDatabaseAccount: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    asDatabaseAuthenticationType: string | undefined
// {"type":"string"}
    asDatabaseName: string | undefined
// {"type":"string"}
    asDatabaseServer: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    authenticationType: string | undefined
// {"type":"string"}
    bizTalkHttpAdapterUrl: string | undefined
// {"type":"string"}
    businessRulesAssembly: string | undefined
// {"type":"string"}
    code: string | undefined
// {"type":"string"}
    configurationFilePath: string | undefined
// {"type":"string"}
    databaseAccount: string | undefined
// {"type":"string"}
    databaseName: string | undefined
// {"type":"string"}
    databaseServer: string | undefined
// {"type":"string"}
    description: string | undefined
// {"type":"string"}
    dwDatabaseAccount: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    dwDatabaseAuthenticationType: string | undefined
// {"type":"string"}
    dwDatabaseName: string | undefined
// {"type":"string"}
    dwDatabaseServer: string | undefined
// {"type":"string"}
    e5AnywhereApiBaseUrl: string | undefined
// {"type":"string"}
    e5AnywhereWebBaseUrl: string | undefined
// {"type":"string"}
    exchangeAccount: string | undefined
// {"type":"string"}
    exchangeAccountDomain: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    exchangeAuthType: string | undefined
// {"type":"string"}
    exchangeUrl: string | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    isDatabaseAccount: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    isDatabaseAuthenticationType: string | undefined
// {"type":"string"}
    isDatabaseServer: string | undefined
// {"type":"string"}
    launchServiceRootDirectory: string | undefined
// {"type":"string"}
    name: string | undefined
// {"type":"string"}
    notificationEmailTemplateUrl: string | undefined
// {"type":"string"}
    reportingServicesAccount: string | undefined
// {"type":"string"}
    reportingServicesDomain: string | undefined
// {"type":"string"}
    reportingServicesUrl: string | undefined
// {"type":"boolean"}
    reportingServicesUseDefaultCredentials: boolean | undefined
// {"type":"string"}
    reportingServicesWsUrl: string | undefined
// {"type":"string"}
    siteUrl: string | undefined
// {"type":"string"}
    wfDatabaseAccount: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    wfDatabaseAuthenticationType: string | undefined
// {"type":"string"}
    wfDatabaseName: string | undefined
// {"type":"string"}
    wfDatabaseServer: string | undefined
// {"format":"int32","type":"integer"}
    workItemTasksOrder: number | undefined
// {"type":"string"}
    wssDatabaseAccountName: string | undefined
// {"enum":["SqlAuthentication","WindowsAuthentication"],"type":"string"}
    wssDatabaseAuthenticationType: string | undefined
// {"type":"string"}
    wssDatabaseName: string | undefined
// {"type":"string"}
    wssServerName: string | undefined
  }

  export class ConfigurationPromotionDefinitionModel {
// {"format":"date-time","type":"string"}
    created: string | undefined
// {"type":"string"}
    createdBy: string | undefined
// {"type":"string"}
    description: string | undefined
// {"type":"string"}
    fileName: string | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"type":"string"}
    label: string | undefined
// {"format":"date-time","type":"string"}
    modified: string | undefined
// {"type":"string"}
    modifiedBy: string | undefined
// {"format":"uuid","type":"string"}
    sourceTenantEnvironmentSolutionId: string | undefined
// {"enum":["Fail","PendingPromotion","Success","WaitingInput"],"type":"string"}
    status: string | undefined
// {"type":"string"}
    taxonomyScope: string | undefined
// {"type":"string"}
    version: string | undefined
  }

  export class ConfigurationPromotionPackageModel {
// {"format":"date-time","type":"string"}
    created: string | undefined
// {"type":"string"}
    createdBy: string | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"format":"date-time","type":"string"}
    modified: string | undefined
// {"type":"string"}
    modifiedBy: string | undefined
// {"format":"byte","type":"string"}
    packageFile: string | undefined
// {"format":"uuid","type":"string"}
    promotionId: string | undefined
  }

  export class ConfigurationScopeModel {
// {"format":"int32","type":"integer"}
    id: number
// {"type":"string"}
    instanceCode: string | undefined
// {"format":"uuid","type":"string"}
    instanceId: string | undefined
// {"type":"string"}
    json: string | undefined
// {"maxLength":50,"type":"string"}
    key: string
// {"format":"date-time","type":"string"}
    modified: string | undefined
// {"maxLength":50,"type":"string"}
    modifiedUser: string | undefined
// {"format":"uuid","type":"string"}
    siteId: string | undefined
// {"type":"string"}
    siteUrl: string | undefined
  }

  export class ConfigurationSectionCreateModel {
// {"maxLength":50,"type":"string"}
    applicationName: string
// {"maxLength":50,"type":"string"}
    sectionName: string
  }

  export class ConfigurationSectionModel {
// {"maxLength":50,"type":"string"}
    applicationName: string
// {"format":"int32","type":"integer"}
    id: number
// {"maxLength":50,"type":"string"}
    sectionName: string
  }

  export class ConfigurationSettingCreateModel {
// {"type":"string"}
    defaultValue: string | undefined
// {"maxLength":50,"type":"string"}
    key: string
// {"format":"int32","type":"integer"}
    sectionId: number
// {"type":"string"}
    value: string | undefined
// {"type":"string"}
    valueType: string | undefined
  }

  export class ConfigurationSettingModel {
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"maxLength":50,"type":"string"}
    key: string
// {"format":"int32","type":"integer"}
    sectionId: number
// {"type":"string"}
    value: string | undefined
// {"type":"string"}
    valueType: string | undefined
  }

  export class ConfigurationSettingUpdateModel {
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"string"}
    value: string | undefined
// {"type":"string"}
    valueType: string | undefined
  }

  export class ContentContentModel {
// {"type":"boolean"}
    applyFoldering: boolean | undefined
// {"format":"int32","type":"integer"}
    contentClassId: number | undefined
// {"format":"uuid","type":"string"}
    contentId: string | undefined
// {"format":"byte","type":"string"}
    document: string | undefined
// {"type":"string"}
    documentName: string | undefined
// {"type":"string"}
    folderPath: string | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Content.MetadataModel"},"type":"array"}
    metaData: ContentMetadataModel[] | undefined ; 
  }

  export class ContentMetadataContainerModel {
// {"format":"uuid","type":"string"}
    contentId: string | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Content.MetadataModel"},"type":"array"}
    metaData: ContentMetadataModel[] | undefined ; 
  }

  export class ContentMetadataModel {
// {"type":"string"}
    name: string | undefined
// {"enum":["Added","Deleted","Unchanged","Updated"],"type":"string"}
    state: string | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class IntegrationYammerYammerAttachmentModel {
// {"type":"string"}
    id: string | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerLikesModel"}
    likes: any | undefined
// {"type":"string"}
    name: string | undefined
// {"type":"string"}
    type: string | undefined
// {"type":"string"}
    url: string | undefined
// {"type":"string"}
    webUrl: string | undefined
  }

  export class IntegrationYammerYammerLikeUserModel {
// {"type":"string"}
    fullName: string | undefined
// {"type":"string"}
    permaLink: string | undefined
// {"type":"string"}
    userId: string | undefined
  }

  export class IntegrationYammerYammerLikesModel {
// {"format":"int32","type":"integer"}
    count: number | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerLikeUserModel"},"type":"array"}
    names: IntegrationYammerYammerLikeUserModel[] | undefined ; 
  }

  export class IntegrationYammerYammerMessageContentModel {
// {"type":"string"}
    parsedText: string | undefined
// {"type":"string"}
    plainText: string | undefined
// {"type":"string"}
    richText: string | undefined
  }

  export class IntegrationYammerYammerMessageModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerAttachmentModel"},"type":"array"}
    attachments: IntegrationYammerYammerAttachmentModel[] | undefined ; 
// {"type":"string"}
    chatClientSequence: string | undefined
// {"type":"string"}
    clientUrl: string | undefined
// {"type":"string"}
    contentExcerpt: string | undefined
// {"type":"string"}
    createdAt: string | undefined
// {"type":"boolean"}
    directMessage: boolean | undefined
// {"type":"string"}
    id: string | undefined
// {"type":"string"}
    language: string | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerLikesModel"}
    likes: any | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerMessageContentModel"}
    messageContent: any | undefined
// {"type":"string"}
    messageType: string | undefined
// {"type":"string"}
    senderId: string | undefined
// {"type":"string"}
    senderType: string | undefined
// {"type":"boolean"}
    systemMessage: boolean | undefined
// {"type":"string"}
    threadId: string | undefined
// {"type":"string"}
    url: string | undefined
// {"type":"string"}
    webUrl: string | undefined
  }

  export class IntegrationYammerYammerPostModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerMessageModel"},"type":"array"}
    messages: IntegrationYammerYammerMessageModel[] | undefined ; 
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Integration.Yammer.YammerReferenceModel"},"type":"array"}
    references: IntegrationYammerYammerReferenceModel[] | undefined ; 
  }

  export class IntegrationYammerYammerReferenceModel {
// {"type":"string"}
    id: string | undefined
// {"type":"string"}
    name: string | undefined
// {"type":"string"}
    type: string | undefined
// {"type":"string"}
    url: string | undefined
// {"type":"string"}
    webUrl: string | undefined
  }

  export class IntegrationYammerYammerTopicModel {
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    networkId: number | undefined
// {"type":"string"}
    normalizedName: string | undefined
// {"type":"string"}
    permalink: string | undefined
// {"type":"string"}
    type: string | undefined
// {"type":"string"}
    url: string | undefined
// {"type":"string"}
    webUrl: string | undefined
  }

  export class ListItemModel {
// {"type":"string"}
    code: string | undefined
// {"items":{"items":{"type":"object"},"type":"array"},"type":"array"}
    columns: any[] | undefined ; 
// {"type":"string"}
    id: string | undefined
// {"type":"string"}
    label: string | undefined
// {"items":{"items":{"type":"object"},"type":"array"},"type":"array"}
    results: any[] | undefined ; 
  }

  export class MonitorsSLAMonitorCategory {
// {"format":"int32","type":"integer"}
    categoryId: number | undefined
// {"type":"string"}
    categoryName: string | undefined
  }

  export class MonitorsSLAMonitorData {
// {"format":"int32","type":"integer"}
    approachingSlaWorkCount: number | undefined
// {"format":"int32","type":"integer"}
    expiredWorkCount: number | undefined
// {"format":"int32","type":"integer"}
    inSlaWorkCount: number | undefined
// {"format":"int32","type":"integer"}
    slaCategoryId: number | undefined
// {"type":"string"}
    slaCategoryName: string | undefined
// {"format":"double","type":"number"}
    totalPropertyValue: number | undefined
  }

  export class MonitorsSlaCompletionData {
// {"format":"double","type":"number"}
    completedPropertyTotal: number | undefined
// {"format":"int32","type":"integer"}
    completedTotal: number | undefined
// {"format":"int32","type":"integer"}
    completedWithinSla: number | undefined
// {"format":"date-time","type":"string"}
    completionDate: string | undefined
// {"format":"double","type":"number"}
    inSlaPropertyTotal: number | undefined
// {"format":"int32","type":"integer"}
    movingAverage: number | undefined
// {"format":"int32","type":"integer"}
    movingAverageWeekly: number | undefined
  }

  export class MonitorsSlaCompletionMonitorModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SlaCompletionData"},"type":"array"}
    data: MonitorsSlaCompletionData[] | undefined ; 
  }

  export class MonitorsSlaInflowData {
// {"format":"int32","type":"integer"}
    activeWorkItemCount: number | undefined
// {"format":"int32","type":"integer"}
    completeWorkItemCount: number | undefined
// {"format":"date-time","type":"string"}
    creationDate: string | undefined
// {"format":"int32","type":"integer"}
    diarisedWorkItemCount: number | undefined
// {"format":"int32","type":"integer"}
    launchWorkItemCount: number | undefined
// {"format":"int32","type":"integer"}
    qaWorkItemCount: number | undefined
// {"format":"int32","type":"integer"}
    rejectedWorkItemCount: number | undefined
  }

  export class MonitorsSlaInflowsMonitorModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SlaInflowData"},"type":"array"}
    data: MonitorsSlaInflowData[] | undefined ; 
  }

  export class MonitorsSlaInventoryData {
// {"format":"date-time","type":"string"}
    interval: string | undefined
// {"format":"int32","type":"integer"}
    statusOneCount: number | undefined
// {"format":"int32","type":"integer"}
    statusThreeCount: number | undefined
// {"format":"int32","type":"integer"}
    statusTwoCount: number | undefined
// {"format":"int32","type":"integer"}
    statusZeroCount: number | undefined
// {"format":"int32","type":"integer"}
    totalCount: number | undefined
  }

  export class MonitorsSlaInventoryMonitorModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SlaInventoryData"},"type":"array"}
    data: MonitorsSlaInventoryData[] | undefined ; 
  }

  export class MonitorsSlaMonitorModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SLAMonitorData"},"type":"array"}
    data: MonitorsSLAMonitorData[] | undefined ; 
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SLAMonitorCategory"},"type":"array"}
    selectedCategories: MonitorsSLAMonitorCategory[] | undefined ; 
  }

  export class MonitorsSlaTeamProductivityCompletionData {
// {"format":"date-time","type":"string"}
    interval: string | undefined
// {"format":"int32","type":"integer"}
    totalCount: number | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.UserWorkCount"},"type":"array"}
    userWorkCounts: MonitorsUserWorkCount[] | undefined ; 
  }

  export class MonitorsSlaTeamProductivityCompletionMonitorModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SlaTeamProductivityCompletionData"},"type":"array"}
    data: MonitorsSlaTeamProductivityCompletionData[] | undefined ; 
  }

  export class MonitorsSlaTeamProductivityFacetimeData {
// {"format":"date-time","type":"string"}
    interval: string | undefined
// {"format":"int32","type":"integer"}
    totalCount: number | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.UserFacetimeCount"},"type":"array"}
    userFacetimeCounts: MonitorsUserFacetimeCount[] | undefined ; 
  }

  export class MonitorsSlaTeamProductivityFacetimeMonitorModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Monitors.SlaTeamProductivityFacetimeData"},"type":"array"}
    data: MonitorsSlaTeamProductivityFacetimeData[] | undefined ; 
  }

  export class MonitorsUserFacetimeCount {
// {"format":"int32","type":"integer"}
    facetimeCount: number | undefined
// {"type":"string"}
    userName: string | undefined
  }

  export class MonitorsUserWorkCount {
// {"format":"int32","type":"integer"}
    completionCount: number | undefined
// {"type":"string"}
    userName: string | undefined
  }

  export class TaxonomyActivityDefinitionContentTypeCreateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"string"}
    code: string
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    postProcessorAssemblyDefinition: any | undefined
// {"type":"string"}
    postProcessorRuleSetName: string | undefined
  }

  export class TaxonomyActivityDefinitionContentTypeModel {
// {"enum":["Check","ContentType","Process"],"type":"string"}
    activityDefinitionType: string | undefined
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"type":"string"}
    name: string | undefined
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    postProcessorAssemblyDefinition: any | undefined
// {"type":"string"}
    postProcessorRuleSetName: string | undefined
  }

  export class TaxonomyActivityDefinitionContentTypeUpdateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    postProcessorAssemblyDefinition: any | undefined
// {"type":"string"}
    postProcessorRuleSetName: string | undefined
  }

  export class TaxonomyActivityDefinitionCreateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"string"}
    code: string
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    postProcessorAssemblyDefinition: any | undefined
// {"type":"string"}
    postProcessorRuleSetName: string | undefined
  }

  export class TaxonomyActivityDefinitionModel {
// {"enum":["Check","ContentType","Process"],"type":"string"}
    activityDefinitionType: string | undefined
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    postProcessorAssemblyDefinition: any | undefined
// {"type":"string"}
    postProcessorRuleSetName: string | undefined
  }

  export class TaxonomyActivityDefinitionUpdateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    postProcessorAssemblyDefinition: any | undefined
// {"type":"string"}
    postProcessorRuleSetName: string | undefined
  }

  export class TaxonomyAdapterCreateModel {
// {"type":"string"}
    assemblyName: string
// {"type":"string"}
    className: string
// {"type":"string"}
    description: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyAdapterModel {
// {"type":"string"}
    assemblyName: string
// {"type":"string"}
    className: string
// {"type":"string"}
    description: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyAdapterUpdateModel {
// {"type":"string"}
    assemblyName: string
// {"type":"string"}
    className: string
// {"type":"string"}
    description: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyAttachmentTypeCreateModel {
// {"format":"int32","type":"integer"}
    archiveLibraryId: number | undefined
// {"enum":["All","Eml","Normal"],"type":"string"}
    attachmentTypeClassification: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"int32","type":"integer"}
    libraryId: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyAttachmentTypeModel {
// {"format":"int32","type":"integer"}
    archiveLibraryId: number | undefined
// {"enum":["All","Eml","Normal"],"type":"string"}
    attachmentTypeClassification: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    libraryId: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyAttachmentTypeRoleCreateModel {
// {"format":"int32","type":"integer"}
    attachmentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isVisible: boolean | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
  }

  export class TaxonomyAttachmentTypeRoleModel {
// {"format":"int32","type":"integer"}
    attachmentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isVisible: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
  }

  export class TaxonomyAttachmentTypeRoleUpdateModel {
// {"format":"int32","type":"integer"}
    attachmentTypeId: number | undefined
// {"type":"boolean"}
    isVisible: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
  }

  export class TaxonomyAttachmentTypeUpdateModel {
// {"format":"int32","type":"integer"}
    archiveLibraryId: number | undefined
// {"enum":["All","Eml","Normal"],"type":"string"}
    attachmentTypeClassification: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    libraryId: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyCacheManagerModel {
// {"type":"string"}
    code: string | undefined
// {"format":"date-time","type":"string"}
    modificationDate: string | undefined
// {"type":"string"}
    modificationUser: string | undefined
  }

  export class TaxonomyCaseNoteTypeCreateModel {
// {"type":"string"}
    description: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyCaseNoteTypeModel {
// {"type":"string"}
    description: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyCaseNoteTypeUpdateModel {
// {"type":"string"}
    description: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyCategory1CreateModel {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    archiveLibraryId: number | undefined
// {"format":"int32","type":"integer"}
    attachmentLibraryId: number | undefined
// {"type":"string"}
    code: string
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    templateLibraryId: number | undefined
  }

  export class TaxonomyCategory1Model {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    archiveLibraryId: number | undefined
// {"format":"int32","type":"integer"}
    attachmentLibraryId: number | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    templateLibraryId: number | undefined
  }

  export class TaxonomyCategory1UpdateModel {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    archiveLibraryId: number | undefined
// {"format":"int32","type":"integer"}
    attachmentLibraryId: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    templateLibraryId: number | undefined
  }

  export class TaxonomyCategory2CreateModel {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"type":"string"}
    code: string
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
  }

  export class TaxonomyCategory2Model {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
  }

  export class TaxonomyCategory2UpdateModel {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
  }

  export class TaxonomyCategory3CreateModel {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"type":"string"}
    code: string
// {"format":"int32","type":"integer"}
    eetMinutes: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"int32","type":"integer"}
    lifeCycleSlaMinutes: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    slaminutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    workClassId: number | undefined
// {"format":"uuid","type":"string"}
    workFlowId: string | undefined
  }

  export class TaxonomyCategory3Model {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    eetMinutes: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    lifeCycleSlaMinutes: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    slaMinutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    workClassId: number | undefined
// {"format":"uuid","type":"string"}
    workFlowId: string | undefined
  }

  export class TaxonomyCategory3UpdateModel {
// {"format":"int32","type":"integer"}
    archiveDays: number | undefined
// {"format":"int32","type":"integer"}
    eetMinutes: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    lifeCycleSlaMinutes: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    slaminutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    workClassId: number | undefined
// {"format":"uuid","type":"string"}
    workFlowId: string | undefined
  }

  export class TaxonomyCategoryActivityAttributeCreateModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"type":"string"}
    code: string
// {"type":"string"}
    displayLabel: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class TaxonomyCategoryActivityAttributeModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"type":"string"}
    code: string | undefined
// {"type":"string"}
    displayLabel: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class TaxonomyCategoryActivityAttributeUpdateModel {
// {"type":"string"}
    displayLabel: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class TaxonomyCategoryActivityDefinitionCreateModel {
// {"format":"int32","type":"integer"}
    activityId: number | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"type":"string"}
    description: string | undefined
// {"format":"int32","type":"integer"}
    eetMinutes: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"type":"string"}
    name: string
// {"enum":["Auto","Mandatory","Optional"],"type":"string"}
    prescription: string | undefined
// {"enum":["Parallel","Series"],"type":"string"}
    process: string | undefined
// {"format":"int32","type":"integer"}
    slaMinutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
  }

  export class TaxonomyCategoryActivityDefinitionModel {
// {"format":"int32","type":"integer"}
    activityId: number | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"type":"string"}
    description: string | undefined
// {"format":"int32","type":"integer"}
    eetMinutes: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"enum":["Auto","Mandatory","Optional"],"type":"string"}
    prescription: string | undefined
// {"enum":["Parallel","Series"],"type":"string"}
    process: string | undefined
// {"format":"int32","type":"integer"}
    slaMinutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
  }

  export class TaxonomyCategoryActivityDefinitionUpdateModel {
// {"type":"string"}
    description: string | undefined
// {"format":"int32","type":"integer"}
    eetMinutes: number | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"enum":["Auto","Mandatory","Optional"],"type":"string"}
    prescription: string | undefined
// {"enum":["Parallel","Series"],"type":"string"}
    process: string | undefined
// {"format":"int32","type":"integer"}
    slaMinutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
  }

  export class TaxonomyCategoryActivityFieldCreateModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"type":"boolean"}
    isDefaultValue: boolean | undefined
// {"type":"string"}
    propertyId: string
  }

  export class TaxonomyCategoryActivityFieldModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isDefaultValue: boolean | undefined
  }

  export class TaxonomyCategoryActivityFieldUpdateModel {
// {"type":"boolean"}
    isDefaultValue: boolean | undefined
  }

  export class TaxonomyCategoryActivityRoleCreateModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"enum":["Read","ReadWrite"],"type":"string"}
    displayMode: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
  }

  export class TaxonomyCategoryActivityRoleModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"enum":["Read","ReadWrite"],"type":"string"}
    displayMode: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
  }

  export class TaxonomyCategoryActivityRoleUpdateModel {
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"enum":["Read","ReadWrite"],"type":"string"}
    displayMode: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
  }

  export class TaxonomyCategoryAttachmentTypeCreateModel {
// {"format":"int32","type":"integer"}
    attachmentTypeId: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyCategoryAttachmentTypeModel {
// {"format":"int32","type":"integer"}
    attachmentTypeId: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyCategoryAttachmentTypeUpdateModel {
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyCategorySiteCreateModel {
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"uuid","type":"string"}
    siteId: string | undefined
// {"type":"boolean"}
    status: boolean | undefined
  }

  export class TaxonomyCategorySiteModel {
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"uuid","type":"string"}
    siteId: string | undefined
// {"type":"boolean"}
    status: boolean | undefined
  }

  export class TaxonomyCategorySiteUpdateModel {
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"uuid","type":"string"}
    siteId: string | undefined
// {"type":"boolean"}
    status: boolean | undefined
  }

  export class TaxonomyContentTypeCustomCreateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    contentProviderType: any
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeCustomModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    contentProviderType: any | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"enum":["Custom","FieldSet","Grid"],"type":"string"}
    type: string | undefined
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeCustomUpdateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    contentProviderType: any
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeFieldSetCreateModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeFieldSetModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"enum":["Custom","FieldSet","Grid"],"type":"string"}
    type: string | undefined
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeFieldSetUpdateModel {
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeGridCreateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    contentProviderType: any | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
// {"enum":["Ascending","Descending"],"type":"string"}
    orderDirection: string | undefined
// {"type":"string"}
    orderPropertyId: string | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeGridModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    contentProviderType: any | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"enum":["Ascending","Descending"],"type":"string"}
    orderDirection: string | undefined
// {"type":"string"}
    orderPropertyId: string | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"enum":["Custom","FieldSet","Grid"],"type":"string"}
    type: string | undefined
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeGridUpdateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    contentProviderType: any | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"enum":["Ascending","Descending"],"type":"string"}
    orderDirection: string | undefined
// {"type":"string"}
    orderPropertyId: string | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyContentTypeModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"enum":["Custom","FieldSet","Grid"],"type":"string"}
    type: string | undefined
// {"$ref":"#/definitions/e5.Domain.LengthDefinitionModel"}
    width: any | undefined
  }

  export class TaxonomyCurrencyCreateModel {
// {"format":"int32","type":"integer"}
    decimalPlaces: number | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    mask: string
// {"type":"string"}
    name: string
  }

  export class TaxonomyCurrencyModel {
// {"format":"int32","type":"integer"}
    decimalPlaces: number | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    mask: string | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyCurrencyUpdateModel {
// {"format":"int32","type":"integer"}
    decimalPlaces: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    mask: string
// {"type":"string"}
    name: string
  }

  export class TaxonomyDocumentTemplateModel {
// {"additionalProperties":{"type":"object"},"type":"object"}
    fields: any | undefined
// {"type":"string"}
    fullUrl: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyEventCreateModel {
// {"type":"string"}
    name: string
  }

  export class TaxonomyEventModel {
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyEventUpdateModel {
// {"type":"string"}
    name: string
  }

  export class TaxonomyExchangeListenerCreateModel {
// {"type":"boolean"}
    activateOnAttach: boolean | undefined
// {"type":"string"}
    archiveUri: string | undefined
// {"enum":["AddToEmailBody","AddToWorkItem","Ignore"],"type":"string"}
    attachOption: string | undefined
// {"$ref":"#/definitions/e5.Domain.AuthenticationDefinitionModel"}
    authentication: any
// {"enum":["NoConversion","PdFtoTiff","TifFtoPdf"],"type":"string"}
    convertOption: string | undefined
// {"type":"string"}
    defaultWorkFilePath: string
// {"enum":["AsConversationView","AsEnhancedPdf","AsPdf","AsTiff","Ignore"],"type":"string"}
    emailBodyOption: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    ignoreIfNoWork: boolean | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    pollingInterval: number | undefined
// {"format":"int32","type":"integer"}
    preProcessorId: number | undefined
// {"type":"string"}
    siteUrl: string
// {"type":"string"}
    uri: string
  }

  export class TaxonomyExchangeListenerModel {
// {"type":"boolean"}
    activateOnAttach: boolean | undefined
// {"type":"string"}
    archiveUri: string | undefined
// {"enum":["AddToEmailBody","AddToWorkItem","Ignore"],"type":"string"}
    attachOption: string | undefined
// {"enum":["NoConversion","PdFtoTiff","TifFtoPdf"],"type":"string"}
    convertOption: string | undefined
// {"type":"string"}
    defaultWorkFilePath: string | undefined
// {"enum":["AsConversationView","AsEnhancedPdf","AsPdf","AsTiff","Ignore"],"type":"string"}
    emailBodyOption: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    ignoreIfNoWork: boolean | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    pollingInterval: number | undefined
// {"format":"int32","type":"integer"}
    preProcessorId: number | undefined
// {"type":"string"}
    siteUrl: string | undefined
// {"type":"string"}
    uri: string | undefined
  }

  export class TaxonomyExchangeListenerPreProcessorCreateModel {
// {"type":"string"}
    configFilePath: string
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    preProcessorType: any
  }

  export class TaxonomyExchangeListenerPreProcessorModel {
// {"type":"string"}
    configFilePath: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    preProcessorType: any | undefined
  }

  export class TaxonomyExchangeListenerPreProcessorUpdateModel {
// {"type":"string"}
    configFilePath: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"$ref":"#/definitions/e5.Domain.AssemblyClassModel"}
    preProcessorType: any
  }

  export class TaxonomyExchangeListenerUpdateModel {
// {"type":"boolean"}
    activateOnAttach: boolean | undefined
// {"type":"string"}
    archiveUri: string | undefined
// {"enum":["AddToEmailBody","AddToWorkItem","Ignore"],"type":"string"}
    attachOption: string | undefined
// {"$ref":"#/definitions/e5.Domain.AuthenticationDefinitionModel"}
    authentication: any
// {"enum":["NoConversion","PdFtoTiff","TifFtoPdf"],"type":"string"}
    convertOption: string | undefined
// {"type":"string"}
    defaultWorkFilePath: string
// {"enum":["AsConversationView","AsEnhancedPdf","AsPdf","AsTiff","Ignore"],"type":"string"}
    emailBodyOption: string | undefined
// {"type":"boolean"}
    ignoreIfNoWork: boolean | undefined
// {"type":"boolean"}
    isActive: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    pollingInterval: number | undefined
// {"format":"int32","type":"integer"}
    preProcessorId: number | undefined
// {"type":"string"}
    siteUrl: string
// {"type":"string"}
    uri: string
  }

  export class TaxonomyFieldDefinitionCaseNoteCreateModel {
// {"type":"string"}
    attributes: string | undefined
// {"format":"int32","type":"integer"}
    caseNoteTypeId: number | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionCaseNoteModel {
// {"type":"string"}
    attributes: string | undefined
// {"format":"int32","type":"integer"}
    caseNoteTypeId: number | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionCaseNoteUpdateModel {
// {"type":"string"}
    attributes: string | undefined
// {"format":"int32","type":"integer"}
    caseNoteTypeId: number | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionCurrencyCreateModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"format":"int32","type":"integer"}
    currencyId: number | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionCurrencyModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"format":"int32","type":"integer"}
    currencyId: number | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionCurrencyUpdateModel {
// {"type":"string"}
    attributes: string | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionLinkCreateModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"type":"string"}
    linkImageUrl: string | undefined
// {"type":"string"}
    linkProperties: string | undefined
// {"type":"string"}
    linkText: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionLinkModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    linkImageUrl: string | undefined
// {"type":"string"}
    linkProperties: string | undefined
// {"type":"string"}
    linkText: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionLinkUpdateModel {
// {"type":"string"}
    attributes: string | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    linkImageUrl: string | undefined
// {"type":"string"}
    linkProperties: string | undefined
// {"type":"string"}
    linkText: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionListCreateModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"int32","type":"integer"}
    listId: number | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionListModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    listId: number | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionListUpdateModel {
// {"type":"string"}
    attributes: string | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionLookupCreateModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"enum":["Input","Text"],"type":"string"}
    lookupDataType: string | undefined
// {"type":"string"}
    lookupField: string
// {"enum":["LookupKey","LookupValidateKey","ReturnAndSave","ReturnOnly","ValidateKey"],"type":"string"}
    lookupFieldType: string | undefined
// {"format":"int32","type":"integer"}
    lookupId: number | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionLookupModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"enum":["Input","Text"],"type":"string"}
    lookupDataType: string | undefined
// {"type":"string"}
    lookupField: string
// {"enum":["LookupKey","LookupValidateKey","ReturnAndSave","ReturnOnly","ValidateKey"],"type":"string"}
    lookupFieldType: string | undefined
// {"format":"int32","type":"integer"}
    lookupId: number | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionLookupUpdateModel {
// {"type":"string"}
    attributes: string | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    lookupField: string
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionSimpleCreateModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    defaultValue: string | undefined
// {"enum":["Checkbox","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionSimpleModel {
// {"type":"string"}
    attributes: string | undefined
// {"maxLength":32,"minLength":0,"type":"string"}
    code: string
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"enum":["Checkbox","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldDataType: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"enum":["Custom","System"],"type":"string"}
    isSystem: string | undefined
// {"maxLength":100,"minLength":0,"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyFieldDefinitionSimpleUpdateModel {
// {"type":"string"}
    attributes: string | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tooltip: string | undefined
  }

  export class TaxonomyLibraryCreateModel {
// {"type":"boolean"}
    applyFoldering: boolean | undefined
// {"type":"string"}
    ftpPassword: string | undefined
// {"format":"int32","type":"integer"}
    ftpPort: number | undefined
// {"type":"string"}
    ftpServer: string | undefined
// {"type":"string"}
    ftpUser: string | undefined
// {"type":"boolean"}
    isArchive: boolean | undefined
// {"type":"string"}
    label: string
// {"enum":["ContentStorageLibraryAdapter","FileNetCslibraryAdapter","OptimaxLibraryAdapter","SharePointCsomLibraryAdapter","SharePointLibraryAdapter"],"type":"string"}
    libraryType: string | undefined
// {"type":"string"}
    name: string
// {"type":"string"}
    url: string
  }

  export class TaxonomyLibraryFieldCreateModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"type":"boolean"}
    isDisplay: boolean | undefined
// {"type":"string"}
    libraryFieldNam: string
// {"format":"int32","type":"integer"}
    libraryId: number | undefined
// {"type":"boolean"}
    populateFromFieldDefinition: boolean | undefined
// {"type":"boolean"}
    populateFromTemplate: boolean | undefined
  }

  export class TaxonomyLibraryFieldModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"type":"boolean"}
    isDisplay: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    libraryFieldName: string | undefined
// {"format":"int32","type":"integer"}
    libraryId: number | undefined
// {"type":"boolean"}
    populateFromFieldDefinition: boolean | undefined
// {"type":"boolean"}
    populateFromTemplate: boolean | undefined
  }

  export class TaxonomyLibraryFieldUpdateModel {
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"type":"string"}
    fieldName: string | undefined
// {"type":"boolean"}
    isDisplay: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"boolean"}
    populateFromFieldDefinition: boolean | undefined
// {"type":"boolean"}
    populateFromTemplate: boolean | undefined
  }

  export class TaxonomyLibraryModel {
// {"type":"boolean"}
    applyFoldering: boolean | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    ftpPassword: string | undefined
// {"format":"int32","type":"integer"}
    ftpPort: number | undefined
// {"type":"string"}
    ftpServer: string | undefined
// {"type":"string"}
    ftpUser: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isArchive: boolean | undefined
// {"type":"string"}
    label: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"enum":["ContentStorageLibraryAdapter","FileNetCslibraryAdapter","OptimaxLibraryAdapter","SharePointCsomLibraryAdapter","SharePointLibraryAdapter"],"type":"string"}
    libraryType: string | undefined
// {"type":"string"}
    name: string | undefined
// {"type":"string"}
    url: string | undefined
  }

  export class TaxonomyLibraryUpdateModel {
// {"type":"boolean"}
    applyFoldering: boolean | undefined
// {"type":"string"}
    ftpPassword: string | undefined
// {"format":"int32","type":"integer"}
    ftpPort: number | undefined
// {"type":"string"}
    ftpServer: string | undefined
// {"type":"string"}
    ftpUser: string | undefined
// {"type":"boolean"}
    isArchive: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"enum":["ContentStorageLibraryAdapter","FileNetCslibraryAdapter","OptimaxLibraryAdapter","SharePointCsomLibraryAdapter","SharePointLibraryAdapter"],"type":"string"}
    libraryType: string | undefined
// {"type":"string"}
    name: string
// {"type":"string"}
    url: string
  }

  export class TaxonomyListCreateModel {
// {"format":"int32","type":"integer"}
    childListId: number | undefined
// {"type":"string"}
    code: string
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyListItemCreateModel {
// {"type":"string"}
    code: string
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    listId: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    parentListItemId: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyListItemModel {
// {"type":"string"}
    code: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    listId: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    parentListItemId: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyListItemUpdateModel {
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    parentListItemId: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class TaxonomyListModel {
// {"format":"int32","type":"integer"}
    childListId: number | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyListUpdateModel {
// {"format":"int32","type":"integer"}
    childListId: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyLocationCreateModel {
// {"format":"date-time","type":"string"}
    businessHoursEndTime: string | undefined
// {"format":"date-time","type":"string"}
    businessHoursStartTime: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    name: string
// {"type":"string"}
    timeZone: string
  }

  export class TaxonomyLocationDayCreateModel {
// {"format":"date-time","type":"string"}
    endTime: string | undefined
// {"type":"boolean"}
    isBusinessDay: boolean | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"format":"date-time","type":"string"}
    startTime: string | undefined
// {"enum":["Friday","Monday","Saturday","Sunday","Thursday","Tuesday","Wednesday"],"type":"string"}
    weekDay: string | undefined
  }

  export class TaxonomyLocationDayModel {
// {"format":"date-time","type":"string"}
    endTime: string | undefined
// {"type":"boolean"}
    isBusinessDay: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"format":"date-time","type":"string"}
    startTime: string | undefined
// {"enum":["Friday","Monday","Saturday","Sunday","Thursday","Tuesday","Wednesday"],"type":"string"}
    weekDay: string | undefined
  }

  export class TaxonomyLocationDayUpdateModel {
// {"format":"date-time","type":"string"}
    endTime: string | undefined
// {"type":"boolean"}
    isBusinessDay: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"format":"date-time","type":"string"}
    startTime: string | undefined
// {"enum":["Friday","Monday","Saturday","Sunday","Thursday","Tuesday","Wednesday"],"type":"string"}
    weekDay: string | undefined
  }

  export class TaxonomyLocationModel {
// {"format":"date-time","type":"string"}
    businessHoursEndTime: string | undefined
// {"format":"date-time","type":"string"}
    businessHoursStartTime: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"type":"string"}
    timeZone: string | undefined
  }

  export class TaxonomyLocationUpdateModel {
// {"format":"date-time","type":"string"}
    businessHoursEndTime: string | undefined
// {"format":"date-time","type":"string"}
    businessHoursStartTime: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"type":"string"}
    timeZone: string | undefined
  }

  export class TaxonomyLookupCreateModel {
// {"format":"int32","type":"integer"}
    adapterId: number | undefined
// {"format":"int64","type":"integer"}
    cacheDuration: number | undefined
// {"format":"int32","type":"integer"}
    cacheRefreshMinutes: number | undefined
// {"type":"boolean"}
    clearCache: boolean | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    label: string
// {"type":"string"}
    location: string
// {"type":"string"}
    lookupUrl: string
// {"type":"boolean"}
    manageCache: boolean | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyLookupModel {
// {"format":"int32","type":"integer"}
    adapterId: number | undefined
// {"format":"int64","type":"integer"}
    cacheDuration: number | undefined
// {"format":"int32","type":"integer"}
    cacheRefreshMinutes: number | undefined
// {"type":"boolean"}
    clearCache: boolean | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    location: string
// {"type":"string"}
    lookupUrl: string
// {"type":"boolean"}
    manageCache: boolean | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyLookupUpdateModel {
// {"format":"int32","type":"integer"}
    adapterId: number | undefined
// {"format":"int64","type":"integer"}
    cacheDuration: number | undefined
// {"format":"int32","type":"integer"}
    cacheRefreshMinutes: number | undefined
// {"type":"boolean"}
    clearCache: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    location: string
// {"type":"string"}
    lookupUrl: string
// {"type":"boolean"}
    manageCache: boolean | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyMenuCreateModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    width: number | undefined
  }

  export class TaxonomyMenuItemDefinitionCreateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"string"}
    code: string
// {"type":"boolean"}
    confirmSelection: boolean | undefined
// {"type":"string"}
    confirmSelectionMessage: string | undefined
// {"type":"string"}
    disabledImageUrl: string | undefined
// {"type":"string"}
    disabledImageUrlLarge: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    imageUrl: string | undefined
// {"type":"string"}
    imageUrlLarge: string | undefined
// {"type":"boolean"}
    isClientSideProcess: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"boolean"}
    validate: boolean | undefined
  }

  export class TaxonomyMenuItemDefinitionModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"string"}
    code: string | undefined
// {"type":"boolean"}
    confirmSelection: boolean | undefined
// {"type":"string"}
    confirmSelectionMessage: string | undefined
// {"type":"string"}
    disabledImageUrl: string | undefined
// {"type":"string"}
    disabledImageUrlLarge: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    imageUrl: string | undefined
// {"type":"string"}
    imageUrlLarge: string | undefined
// {"type":"boolean"}
    isClientSideProcess: boolean | undefined
// {"type":"string"}
    label: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"boolean"}
    validate: boolean | undefined
  }

  export class TaxonomyMenuItemDefinitionUpdateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    assemblyDefinition: any | undefined
// {"type":"boolean"}
    confirmSelection: boolean | undefined
// {"type":"string"}
    confirmSelectionMessage: string | undefined
// {"type":"string"}
    disabledImageUrl: string | undefined
// {"type":"string"}
    disabledImageUrlLarge: string | undefined
// {"type":"string"}
    imageUrl: string | undefined
// {"type":"string"}
    imageUrlLarge: string | undefined
// {"type":"boolean"}
    isClientSideProcess: boolean | undefined
// {"type":"string"}
    label: string
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"type":"boolean"}
    validate: boolean | undefined
  }

  export class TaxonomyMenuModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    width: number | undefined
  }

  export class TaxonomyMenuRoleModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    menuItemId: number | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
// {"type":"boolean"}
    visibility: boolean | undefined
  }

  export class TaxonomyMenuUpdateModel {
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    width: number | undefined
  }

  export class TaxonomyMenuViewCreateModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    menuItemId: number | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
// {"type":"boolean"}
    visibility: boolean | undefined
  }

  export class TaxonomyMenuViewUpdateModel {
// {"format":"int32","type":"integer"}
    menuItemId: number | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
// {"type":"boolean"}
    visibility: boolean | undefined
  }

  export class TaxonomyPriorityCreateModel {
// {"type":"string"}
    code: string
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyPriorityModel {
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyPriorityUpdateModel {
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyPublicHolidayCreateModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"date-time","type":"string"}
    holidayDate: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyPublicHolidayModel {
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"date-time","type":"string"}
    holidayDate: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyPublicHolidayUpdateModel {
// {"format":"date-time","type":"string"}
    holidayDate: string | undefined
// {"format":"int32","type":"integer"}
    locationId: number | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyRoleCreateModel {
// {"format":"int32","type":"integer"}
    accessOrder: number | undefined
// {"type":"boolean"}
    allowAttach: boolean | undefined
// {"type":"boolean"}
    allowConvertAttachments: boolean | undefined
// {"type":"boolean"}
    allowDetach: boolean | undefined
// {"type":"boolean"}
    allowEdit: boolean | undefined
// {"type":"boolean"}
    allowPerform: boolean | undefined
// {"type":"boolean"}
    allowPrescribe: boolean | undefined
// {"type":"boolean"}
    allowTearOff: boolean | undefined
// {"type":"boolean"}
    allowTearOffSplit: boolean | undefined
// {"type":"boolean"}
    allowTearOffSplitWithDelete: boolean | undefined
// {"type":"boolean"}
    allowUnlock: boolean | undefined
// {"type":"boolean"}
    allowViewActivities: boolean | undefined
// {"type":"boolean"}
    allowViewAttachments: boolean | undefined
// {"type":"boolean"}
    allowViewCaseNotes: boolean | undefined
// {"type":"boolean"}
    allowViewChildren: boolean | undefined
// {"type":"boolean"}
    allowViewHistory: boolean | undefined
// {"type":"boolean"}
    allowViewManageActivities: boolean | undefined
// {"type":"string"}
    code: string
// {"format":"int32","type":"integer"}
    defaultWorkTab: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomyRoleModel {
// {"format":"int32","type":"integer"}
    accessOrder: number | undefined
// {"type":"boolean"}
    allowAttach: boolean | undefined
// {"type":"boolean"}
    allowConvertAttachments: boolean | undefined
// {"type":"boolean"}
    allowDetach: boolean | undefined
// {"type":"boolean"}
    allowEdit: boolean | undefined
// {"type":"boolean"}
    allowPerform: boolean | undefined
// {"type":"boolean"}
    allowPrescribe: boolean | undefined
// {"type":"boolean"}
    allowTearOff: boolean | undefined
// {"type":"boolean"}
    allowTearOffSplit: boolean | undefined
// {"type":"boolean"}
    allowTearOffSplitWithDelete: boolean | undefined
// {"type":"boolean"}
    allowUnlock: boolean | undefined
// {"type":"boolean"}
    allowViewActivities: boolean | undefined
// {"type":"boolean"}
    allowViewAttachments: boolean | undefined
// {"type":"boolean"}
    allowViewCaseNotes: boolean | undefined
// {"type":"boolean"}
    allowViewChildren: boolean | undefined
// {"type":"boolean"}
    allowViewHistory: boolean | undefined
// {"type":"boolean"}
    allowViewManageActivities: boolean | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    defaultWorkTab: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class TaxonomyRoleUpdateModel {
// {"format":"int32","type":"integer"}
    accessOrder: number | undefined
// {"type":"boolean"}
    allowAttach: boolean | undefined
// {"type":"boolean"}
    allowConvertAttachments: boolean | undefined
// {"type":"boolean"}
    allowDetach: boolean | undefined
// {"type":"boolean"}
    allowEdit: boolean | undefined
// {"type":"boolean"}
    allowPerform: boolean | undefined
// {"type":"boolean"}
    allowPrescribe: boolean | undefined
// {"type":"boolean"}
    allowTearOff: boolean | undefined
// {"type":"boolean"}
    allowTearOffSplit: boolean | undefined
// {"type":"boolean"}
    allowTearOffSplitWithDelete: boolean | undefined
// {"type":"boolean"}
    allowUnlock: boolean | undefined
// {"type":"boolean"}
    allowViewActivities: boolean | undefined
// {"type":"boolean"}
    allowViewAttachments: boolean | undefined
// {"type":"boolean"}
    allowViewCaseNotes: boolean | undefined
// {"type":"boolean"}
    allowViewChildren: boolean | undefined
// {"type":"boolean"}
    allowViewHistory: boolean | undefined
// {"type":"boolean"}
    allowViewManageActivities: boolean | undefined
// {"format":"int32","type":"integer"}
    defaultWorkTab: number | undefined
// {"type":"string"}
    name: string
  }

  export class TaxonomySearchActivityFieldCreateModel {
// {"type":"string"}
    activityFieldDefinitionId: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    fieldStatus: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class TaxonomySearchActivityFieldModel {
// {"type":"string"}
    activityFieldDefinitionId: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    fieldStatus: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class TaxonomySearchActivityFieldUpdateModel {
// {"type":"string"}
    activityFieldDefinitionId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    fieldStatus: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class TaxonomySearchDefinitionContentTypeCreateModel {
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
// {"format":"int32","type":"integer"}
    zoneSequence: number | undefined
  }

  export class TaxonomySearchDefinitionContentTypeModel {
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
// {"format":"int32","type":"integer"}
    zoneSequence: number | undefined
  }

  export class TaxonomySearchDefinitionContentTypeUpdateModel {
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
// {"format":"int32","type":"integer"}
    zoneSequence: number | undefined
  }

  export class TaxonomySearchDefinitionCreateModel {
// {"format":"int32","type":"integer"}
    activityContentTypeId: number | undefined
// {"format":"int32","type":"integer"}
    activityDefinitionId: number | undefined
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    isPublished: boolean | undefined
// {"format":"int32","type":"integer"}
    maximumReturned: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
// {"enum":["WorkAndActivity","WorkOnly"],"type":"string"}
    searchType: string | undefined
// {"type":"boolean"}
    showNextActivity: boolean | undefined
// {"type":"boolean"}
    showSearchAllOption: boolean | undefined
// {"type":"string"}
    sortFieldId: string | undefined
// {"enum":["Ascending","Descending"],"type":"string"}
    sortOrder: string | undefined
// {"format":"uuid","type":"string"}
    zoneTemplateId: string | undefined
  }

  export class TaxonomySearchDefinitionModel {
// {"format":"int32","type":"integer"}
    activityContentTypeId: number | undefined
// {"format":"int32","type":"integer"}
    activityDefinitionId: number | undefined
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isPublished: boolean | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maximumReturned: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
// {"enum":["WorkAndActivity","WorkOnly"],"type":"string"}
    searchType: string | undefined
// {"type":"boolean"}
    showNextActivity: boolean | undefined
// {"type":"boolean"}
    showSearchAllOption: boolean | undefined
// {"type":"string"}
    sortFieldId: string | undefined
// {"enum":["Ascending","Descending"],"type":"string"}
    sortOrder: string | undefined
// {"format":"uuid","type":"string"}
    zoneTemplateId: string | undefined
  }

  export class TaxonomySearchDefinitionUpdateModel {
// {"format":"int32","type":"integer"}
    activityContentTypeId: number | undefined
// {"format":"int32","type":"integer"}
    activityDefinitionId: number | undefined
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    maximumReturned: number | undefined
// {"type":"string"}
    name: string
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"format":"int32","type":"integer"}
    roleId: number | undefined
// {"enum":["WorkAndActivity","WorkOnly"],"type":"string"}
    searchType: string | undefined
// {"type":"boolean"}
    showNextActivity: boolean | undefined
// {"type":"boolean"}
    showSearchAllOption: boolean | undefined
// {"type":"string"}
    sortFieldId: string | undefined
// {"enum":["Ascending","Descending"],"type":"string"}
    sortOrder: string | undefined
// {"format":"uuid","type":"string"}
    zoneTemplateId: string | undefined
  }

  export class TaxonomySearchFieldCreateModel {
// {"format":"int32","type":"integer"}
    activityDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    activityStatus: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    fieldStatus: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class TaxonomySearchFieldModel {
// {"format":"int32","type":"integer"}
    activityDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    activityStatus: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    fieldStatus: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class TaxonomySearchFieldUpdateModel {
// {"format":"int32","type":"integer"}
    activityDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    activityStatus: string | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"enum":["IsAvailable","IsHidden","IsSelected"],"type":"string"}
    fieldStatus: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class TaxonomyStatusCreateModel {
// {"type":"string"}
    code: string
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    eventAssemblyName: any | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"type":"boolean"}
    lifecycleSlaExclusion: boolean | undefined
// {"type":"string"}
    name: string
// {"type":"boolean"}
    slaExclusion: boolean | undefined
// {"enum":["Completed","InProgress"],"type":"string"}
    statusType: string | undefined
// {"type":"boolean"}
    workflowInitialisationExclusion: boolean | undefined
  }

  export class TaxonomyStatusModel {
// {"type":"string"}
    code: string | undefined
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    eventAssemblyName: any | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"boolean"}
    lifecycleSlaExclusion: boolean | undefined
// {"type":"string"}
    name: string | undefined
// {"type":"boolean"}
    slaExclusion: boolean | undefined
// {"enum":["Completed","InProgress"],"type":"string"}
    statusType: string | undefined
// {"type":"boolean"}
    workflowInitialisationExclusion: boolean | undefined
  }

  export class TaxonomyStatusUpdateModel {
// {"$ref":"#/definitions/e5.Domain.AssemblyDefinitionModel"}
    eventAssemblyName: any | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"boolean"}
    lifecycleSlaExclusion: boolean | undefined
// {"type":"string"}
    name: string
// {"type":"boolean"}
    slaExclusion: boolean | undefined
// {"enum":["Completed","InProgress"],"type":"string"}
    statusType: string | undefined
// {"type":"boolean"}
    workflowInitialisationExclusion: boolean | undefined
  }

  export class TaxonomyZoneTemplateCreateModel {
// {"type":"string"}
    imageHref: string | undefined
// {"type":"string"}
    template: string | undefined
  }

  export class TaxonomyZoneTemplateModel {
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"type":"string"}
    imageHref: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    template: string | undefined
  }

  export class TaxonomyZoneTemplateUpdateModel {
// {"type":"string"}
    imageHref: string | undefined
// {"format":"date-time","type":"string"}
    lastModified: string | undefined
// {"type":"string"}
    template: string | undefined
  }

  export class UserGroupModel {
// {"readOnly":true,"type":"string"}
    id: string | undefined
// {"readOnly":true,"type":"string"}
    title: string | undefined
  }

  export class UserModel {
// {"type":"string"}
    email: string | undefined
// {"type":"string"}
    firstName: string | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.UserGroupModel"},"type":"array"}
    groups: UserGroupModel[] | undefined ; 
// {"type":"string"}
    id: string | undefined
// {"type":"string"}
    lastName: string | undefined
// {"readOnly":true,"type":"string"}
    name: string | undefined
// {"type":"string"}
    userName: string | undefined
  }

  export class UserProfileModel {
// {"type":"string"}
    displayName: string | undefined
// {"type":"string"}
    email: string | undefined
// {"type":"string"}
    firstName: string | undefined
// {"type":"string"}
    id: string | undefined
// {"type":"string"}
    lastName: string | undefined
// {"readOnly":true,"type":"string"}
    name: string | undefined
// {"type":"string"}
    userName: string | undefined
  }

  export class WorkGetNextIdResponse {
// {"type":"boolean"}
    hasLock: boolean | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
  }

  export class WorkGetNextResponse {
// {"type":"boolean"}
    hasLock: boolean | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemModel"}
    workItem: any | undefined
  }

  export class WorkGetNextValueResponse {
// {"format":"double","type":"number"}
    getNextValue: number | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemModel"}
    workItem: any | undefined
  }

  export class WorkIsLockedWorkItemResponse {
// {"format":"uuid","readOnly":true,"type":"string"}
    id: string | undefined
// {"readOnly":true,"type":"boolean"}
    isLocked: boolean | undefined
// {"format":"date-time","readOnly":true,"type":"string"}
    lockDate: string | undefined
// {"readOnly":true,"type":"string"}
    lockUser: string | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemModel"}
    workItem: any | undefined
  }

  export class WorkLockWorkItemResponse {
// {"format":"uuid","readOnly":true,"type":"string"}
    id: string | undefined
// {"format":"date-time","readOnly":true,"type":"string"}
    lockDate: string | undefined
// {"readOnly":true,"type":"string"}
    lockUser: string | undefined
// {"readOnly":true,"type":"boolean"}
    success: boolean | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemModel"}
    workItem: any | undefined
  }

  export class WorkUnLockWorkItemResponse {
// {"format":"uuid","readOnly":true,"type":"string"}
    id: string | undefined
// {"format":"date-time","readOnly":true,"type":"string"}
    lockDate: string | undefined
// {"readOnly":true,"type":"string"}
    lockUser: string | undefined
// {"readOnly":true,"type":"boolean"}
    success: boolean | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemModel"}
    workItem: any | undefined
  }

  export class WorkClassChildrenModel {
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"type":"string"}
    category1Name: string | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"type":"string"}
    category2Name: string | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"type":"string"}
    category3Name: string | undefined
// {"type":"string"}
    createdBy: string | undefined
// {"format":"date-time","type":"string"}
    createdDateTime: string | undefined
// {"format":"uuid","type":"string"}
    externalId: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    modifiedBy: string | undefined
// {"format":"date-time","type":"string"}
    modifiedDateTime: string | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    workClassId: number | undefined
  }

  export class WorkItemCaseNoteCreateModel {
// {"type":"string"}
    fieldId: string | undefined
// {"type":"string"}
    fieldValue: string | undefined
// {"type":"string"}
    userName: string | undefined
  }

  export class WorkItemCreateModel {
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"uuid","readOnly":true,"type":"string"}
    id: string | undefined
// {"format":"int32","readOnly":true,"type":"integer"}
    reference: number | undefined
// {"enum":["Active","Complete","Diarised","Launch","Migrated","QA","Rejected"],"type":"string"}
    statusId: string | undefined
// {"format":"int32","readOnly":true,"type":"integer"}
    workClassId: number | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemFieldModel"},"type":"array"}
    workItemFields: WorkItemFieldModel[] | undefined ; 
  }

  export class WorkItemEventCreateModel {
// {"type":"string"}
    detail: string | undefined
// {"format":"int32","type":"integer"}
    eventId: number | undefined
// {"type":"string"}
    eventUser: string | undefined
  }

  export class WorkItemFieldModel {
// {"type":"string"}
    fieldId: string | undefined
// {"enum":["CaseNote","Checkbox","Currency","Date","DateTime","Decimal","Grid","Guid","Input","Integer","Link","List","Lookup","Reference","SiteGroup","Text","User"],"type":"string"}
    fieldType: string | undefined
// {"type":"string"}
    fieldValue: string | undefined
  }

  export class WorkItemFieldUpdateModel {
// {"type":"string"}
    fieldId: string | undefined
// {"type":"string"}
    fieldValue: string | undefined
  }

  export class WorkItemFieldsUpdateModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemFieldUpdateModel"},"type":"array"}
    workItemFields: WorkItemFieldUpdateModel[] | undefined ; 
  }

  export class WorkItemModel {
// {"type":"string"}
    allocation: string | undefined
// {"format":"date-time","type":"string"}
    assignedDate: string | undefined
// {"type":"string"}
    assignedUser: string | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"date-time","type":"string"}
    completionDate: string | undefined
// {"type":"string"}
    completionUser: string | undefined
// {"format":"date-time","type":"string"}
    creationDate: string | undefined
// {"type":"string"}
    creationUser: string | undefined
// {"format":"double","type":"number"}
    getNextValue: number | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"format":"date-time","type":"string"}
    lifecycleSlaExpiryDate: string | undefined
// {"format":"date-time","type":"string"}
    lockDate: string | undefined
// {"type":"string"}
    lockUser: string | undefined
// {"format":"uuid","type":"string"}
    originId: string | undefined
// {"format":"uuid","type":"string"}
    parentId: string | undefined
// {"format":"int32","type":"integer"}
    priority: number | undefined
// {"format":"int32","type":"integer"}
    reference: number | undefined
// {"format":"int32","type":"integer"}
    siteGroup: number | undefined
// {"format":"date-time","type":"string"}
    slaExpiryDate: string | undefined
// {"type":"string"}
    statusDetail: string | undefined
// {"format":"date-time","type":"string"}
    statusEventDate: string | undefined
// {"format":"int32","type":"integer"}
    statusId: number | undefined
// {"format":"int32","type":"integer"}
    subCategory3Id: number | undefined
// {"format":"int32","type":"integer"}
    workClassId: number | undefined
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Work.WorkItemFieldModel"},"type":"array"}
    workItemFields: WorkItemFieldModel[] | undefined ; 
// {"format":"uuid","type":"string"}
    workflowVersionId: string | undefined
  }

  export class WorkRelatedItemModel {
// {"type":"string"}
    allocation: string | undefined
// {"format":"int32","type":"integer"}
    attachmentCount: number | undefined
// {"items":{"$ref":"#/definitions/System.Collections.Generic.KeyValuePair`2[[System.String, mscorlib, Version=4.0.0.0, Culture=neutral, PublicKeyToken=b77a5c561934e089],[System.String, mscorlib, Version=4.0.0.0, Culture=neutral, PublicKeyToken=b77a5c561934e089]]"},"type":"array"}
    fieldValues: any[] | undefined ; 
// {"format":"int32","type":"integer"}
    generation: number | undefined
// {"type":"string"}
    hierarchy: string | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"format":"date-time","type":"string"}
    lockDate: string | undefined
// {"type":"string"}
    lockUser: string | undefined
// {"format":"uuid","type":"string"}
    parentId: string | undefined
  }

  export class WorkRelatedItemsModel {
// {"items":{"$ref":"#/definitions/e5.Domain.Models.Work.WorkRelatedItemModel"},"type":"array"}
    relatedItems: WorkRelatedItemModel[] | undefined ; 
// {"format":"int32","type":"integer"}
    total: number | undefined
  }

  export class FoundationTaxonomyControlItemFModel {
// {"additionalProperties":{"type":"object"},"type":"object"}
    attributes: any | undefined
// {"type":"boolean"}
    enabled: boolean | undefined
// {"type":"string"}
    text: string | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class FoundationTaxonomyFieldFModel {
// {"type":"string"}
    attributes: string | undefined
// {"type":"string"}
    condition: string | undefined
// {"type":"string"}
    cssClass: string | undefined
// {"type":"string"}
    dataEndPoint: string | undefined
// {"type":"string"}
    defaultValue: string | undefined
// {"type":"string"}
    description: string | undefined
// {"type":"string"}
    fieldCssClass: string | undefined
// {"format":"int32","type":"integer"}
    fieldDataType: number | undefined
// {"type":"string"}
    fieldSetId: string | undefined
// {"format":"int32","type":"integer"}
    fieldSetType: number | undefined
// {"type":"string"}
    image: string | undefined
// {"type":"boolean"}
    isExportable: boolean | undefined
// {"type":"boolean"}
    isReadOnly: boolean | undefined
// {"type":"boolean"}
    isRequired: boolean | undefined
// {"type":"string"}
    label: string | undefined
// {"type":"string"}
    labelCssClass: string | undefined
// {"format":"int32","type":"integer"}
    listId: number | undefined
// {"format":"int32","type":"integer"}
    lookupId: number | undefined
// {"format":"int32","type":"integer"}
    maxLength: number | undefined
// {"type":"string"}
    onChange: string | undefined
// {"type":"string"}
    onClick: string | undefined
// {"type":"string"}
    pattern: string | undefined
// {"type":"string"}
    placeholder: string | undefined
// {"type":"string"}
    rangeMaximum: string | undefined
// {"type":"string"}
    rangeMinimum: string | undefined
// {"type":"object"}
    resolvedValue: any | undefined
// {"type":"string"}
    styles: string | undefined
// {"type":"string"}
    tabId: string | undefined
// {"type":"string"}
    tabName: string | undefined
// {"type":"string"}
    tooltip: string | undefined
// {"type":"string"}
    validationMessage: string | undefined
// {"type":"object"}
    value: any | undefined
// {"type":"string"}
    workFieldId: string
// {"type":"string"}
    zoneId: string | undefined
  }

  export class FoundationTaxonomyFieldGridRowModel {
// {"format":"int32","type":"integer"}
    rowId: number | undefined
// {"format":"int32","type":"integer"}
    rowNumber: number | undefined
// {"format":"int32","type":"integer"}
    totalCount: number | undefined
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Taxonomy.FieldFModel"},"type":"array"}
    workFields: FoundationTaxonomyFieldFModel[] | undefined ; 
  }

  export class FoundationTaxonomyFieldSetFModel {
// {"type":"string"}
    fieldSetId: string
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Taxonomy.FieldGridRowModel"},"type":"array"}
    fieldSetRows: FoundationTaxonomyFieldGridRowModel[] | undefined ; 
// {"format":"int32","type":"integer"}
    fieldSetType: number | undefined
  }

  export class FoundationTaxonomyFilteredListFModel {
// {"type":"boolean"}
    endOfItems: boolean | undefined
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Taxonomy.ControlItemFModel"},"type":"array"}
    items: FoundationTaxonomyControlItemFModel[] | undefined ; 
// {"type":"string"}
    message: string | undefined
// {"format":"int32","type":"integer"}
    numberOfItems: number | undefined
// {"type":"string"}
    text: string | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class FoundationTaxonomyListFModel {
// {"format":"int32","type":"integer"}
    childId: number | undefined
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Taxonomy.ListItemFModel"},"type":"array"}
    items: FoundationTaxonomyListItemFModel[] | undefined ; 
// {"items":{"type":"string"},"type":"array"}
    metadata: string[] | undefined ; 
// {"type":"string"}
    name: string | undefined
  }

  export class FoundationTaxonomyListItemFModel {
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class FoundationTaxonomyMenuItemFModel {
// {"type":"string"}
    assemblyName: string | undefined
// {"type":"string"}
    className: string | undefined
// {"type":"boolean"}
    clientSideProcess: boolean | undefined
// {"type":"string"}
    code: string | undefined
// {"type":"boolean"}
    confirmSelection: boolean | undefined
// {"type":"string"}
    confirmSelectionMessage: string | undefined
// {"type":"string"}
    disabledImageUrl: string | undefined
// {"type":"string"}
    disabledImageUrlLarge: string | undefined
// {"type":"boolean"}
    enabled: boolean | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    imageUrl: string | undefined
// {"type":"string"}
    imageUrlLarge: string | undefined
// {"type":"string"}
    label: string | undefined
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"type":"string"}
    methodName: string | undefined
// {"format":"double","type":"number"}
    sortOrder: number | undefined
// {"type":"object"}
    status: any | undefined
// {"type":"boolean"}
    validate: boolean | undefined
  }

  export class FoundationWorkAttachmentFModel {
// {"type":"string"}
    attachmentId: string | undefined
// {"format":"int32","type":"integer"}
    attachmentTypeId: number | undefined
// {"type":"string"}
    documentName: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"object"}
    metaData: any | undefined
// {"format":"int32","type":"integer"}
    parentId: number | undefined
// {"format":"uuid","type":"string"}
    workId: string | undefined
  }

  export class FoundationWorkCaseNoteFModel {
// {"type":"string"}
    caseNote: string | undefined
// {"format":"date-time","type":"string"}
    caseNoteDate: string | undefined
// {"type":"string"}
    caseNoteType: string | undefined
// {"type":"string"}
    caseNoteUser: string | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    propertyId: string | undefined
// {"format":"int32","type":"integer"}
    reference: number | undefined
// {"format":"uuid","type":"string"}
    workId: string | undefined
  }

  export class FoundationWorkCaseNoteResultModel {
// {"format":"int32","type":"integer"}
    page: number | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.CaseNoteFModel"},"type":"array"}
    results: FoundationWorkCaseNoteFModel[] | undefined ; 
// {"format":"int32","type":"integer"}
    total: number | undefined
  }

  export class FoundationWorkContentDiariseReasonFModel {
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    reason: string | undefined
  }

  export class FoundationWorkConversationFModel {
// {"type":"string"}
    author: string | undefined
// {"type":"boolean"}
    hasAttachments: boolean | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.LastActivityFModel"}
    lastActivity: any | undefined
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.ConversationMessageFModel"},"type":"array"}
    messages: FoundationWorkConversationMessageFModel[] | undefined ; 
// {"type":"string"}
    subject: string | undefined
// {"format":"uuid","type":"string"}
    workId: string | undefined
  }

  export class FoundationWorkConversationGroupFModel {
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.ConversationFModel"},"type":"array"}
    conversations: FoundationWorkConversationFModel[] | undefined ; 
  }

  export class FoundationWorkConversationMessageFModel {
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.AttachmentFModel"},"type":"array"}
    attachments: FoundationWorkAttachmentFModel[] | undefined ; 
// {"type":"string"}
    author: string | undefined
// {"type":"string"}
    bcc: string | undefined
// {"type":"string"}
    body: string | undefined
// {"type":"string"}
    bodyHtml: string | undefined
// {"type":"string"}
    cc: string | undefined
// {"type":"string"}
    emailId: string | undefined
// {"type":"string"}
    from: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"boolean"}
    isFirst: boolean | undefined
// {"type":"string"}
    messageType: string | undefined
// {"type":"string"}
    parentEmailId: string | undefined
// {"format":"date-time","type":"string"}
    received: string | undefined
// {"type":"string"}
    replyBodyHtml: string | undefined
// {"type":"string"}
    replyTo: string | undefined
// {"type":"string"}
    subject: string | undefined
// {"format":"int32","type":"integer"}
    templateId: number | undefined
// {"type":"string"}
    threadId: string | undefined
// {"type":"string"}
    to: string | undefined
// {"format":"uuid","type":"string"}
    workId: string | undefined
  }

  export class FoundationWorkDocumentReferenceFModel {
// {"type":"string"}
    documentUrl: string | undefined
// {"type":"string"}
    name: string | undefined
  }

  export class FoundationWorkFileFModel {
// {"type":"string"}
    fileBase64: string | undefined
// {"type":"string"}
    fileName: string | undefined
  }

  export class FoundationWorkFilterComparisonModel {
// {"type":"string"}
    field: string | undefined
// {"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.FilterFModel"}
    filter: any | undefined
// {"type":"string"}
    operator: string | undefined
// {"type":"string"}
    value: string | undefined
  }

  export class FoundationWorkFilterFModel {
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.FilterComparisonModel"},"type":"array"}
    filters: FoundationWorkFilterComparisonModel[] | undefined ; 
// {"type":"string"}
    logic: string | undefined
  }

  export class FoundationWorkFindWorkItemColumnDefModel {
// {"type":"string"}
    code: string | undefined
// {"type":"string"}
    label: string | undefined
// {"type":"string"}
    type: string | undefined
  }

  export class FoundationWorkFindWorkItemResultModel {
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.FindWorkItemColumnDefModel"},"type":"array"}
    columns: FoundationWorkFindWorkItemColumnDefModel[] | undefined ; 
// {"format":"int32","type":"integer"}
    findClassId: number | undefined
// {"format":"int32","type":"integer"}
    page: number | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"format":"int32","type":"integer"}
    resultCount: number | undefined
// {"items":{"items":{"type":"object"},"type":"array"},"type":"array"}
    results: any[] | undefined ; 
// {"format":"int32","type":"integer"}
    total: number | undefined
  }

  export class FoundationWorkLastActivityFModel {
// {"type":"string"}
    emailBodyPlainText: string | undefined
// {"format":"date-time","type":"string"}
    received: string | undefined
  }

  export class FoundationWorkPropertyValueFModel {
// {"type":"object"}
    resolvedValue: any | undefined
// {"type":"object"}
    value: any | undefined
// {"format":"uuid","type":"string"}
    workId: string | undefined
  }

  export class FoundationWorkTaskAttributeFModel {
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    dataType: number | undefined
// {"type":"string"}
    displayLabel: string | undefined
// {"format":"double","type":"number"}
    sortOrder: number | undefined
// {"format":"int32","type":"integer"}
    taskAttributeId: number | undefined
// {"type":"object"}
    value: any | undefined
  }

  export class FoundationWorkTaskFModel {
// {"format":"date-time","type":"string"}
    assignedDate: string | undefined
// {"type":"string"}
    assignedUser: string | undefined
// {"items":{"$ref":"#/definitions/e5.Foundation.Domain.Models.Work.TaskAttributeFModel"},"type":"array"}
    attributes: FoundationWorkTaskAttributeFModel[] | undefined ; 
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"format":"date-time","type":"string"}
    completionDate: string | undefined
// {"type":"string"}
    completionUser: string | undefined
// {"type":"string"}
    description: string | undefined
// {"type":"boolean"}
    enableActivityPostProcessor: boolean | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"format":"int32","type":"integer"}
    indexId: number | undefined
// {"type":"string"}
    knowledgeBaseUrl: string | undefined
// {"format":"int32","type":"integer"}
    menuId: number | undefined
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    prescription: number | undefined
// {"format":"date-time","type":"string"}
    prescriptionDate: string | undefined
// {"type":"string"}
    prescriptionUser: string | undefined
// {"format":"int32","type":"integer"}
    process: number | undefined
// {"format":"date-time","type":"string"}
    slaExpiryDate: string | undefined
// {"format":"int32","type":"integer"}
    slaMinutes: number | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
// {"format":"int32","type":"integer"}
    status: number | undefined
// {"type":"string"}
    templateFolder: string | undefined
// {"format":"int32","type":"integer"}
    type: number | undefined
// {"format":"uuid","type":"string"}
    workId: string | undefined
// {"format":"int32","type":"integer"}
    workTaskId: number | undefined
  }

  export class FoundationWorkItemFModel {
// {"type":"string"}
    allocation: string | undefined
// {"format":"int32","type":"integer"}
    archiveId: number | undefined
// {"type":"boolean"}
    archived: boolean | undefined
// {"format":"date-time","type":"string"}
    assignedDate: string | undefined
// {"type":"string"}
    assignedUser: string | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"date-time","type":"string"}
    completionDate: string | undefined
// {"type":"string"}
    completionUser: string | undefined
// {"format":"date-time","type":"string"}
    creationDate: string | undefined
// {"type":"string"}
    creationUser: string | undefined
// {"format":"double","type":"number"}
    getNextValue: number | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"type":"boolean"}
    isPartOfFamilyLock: boolean | undefined
// {"format":"date-time","type":"string"}
    lockDate: string | undefined
// {"type":"string"}
    lockUser: string | undefined
// {"type":"boolean"}
    lockedByOther: boolean | undefined
// {"format":"uuid","type":"string"}
    parentId: string | undefined
// {"format":"int32","type":"integer"}
    previousStatus: number | undefined
// {"format":"int32","type":"integer"}
    priority: number | undefined
// {"type":"boolean"}
    readOnly: boolean | undefined
// {"format":"int32","type":"integer"}
    reference: number | undefined
// {"format":"date-time","type":"string"}
    slaExpiryDate: string | undefined
// {"format":"int32","type":"integer"}
    status: number | undefined
// {"type":"string"}
    statusDetail: string | undefined
// {"format":"date-time","type":"string"}
    statusEventDate: string | undefined
// {"type":"string"}
    url: string | undefined
// {"format":"uuid","type":"string"}
    workFlowId: string | undefined
// {"format":"uuid","type":"string"}
    workflowVersion: string | undefined
  }

  export class FoundationWorkWorkTaskFModel {
// {"format":"date-time","type":"string"}
    assignedDate: string | undefined
// {"type":"string"}
    assignedUser: string | undefined
// {"format":"int32","type":"integer"}
    category1Id: number | undefined
// {"format":"int32","type":"integer"}
    category2Id: number | undefined
// {"format":"int32","type":"integer"}
    category3Id: number | undefined
// {"format":"int32","type":"integer"}
    categoryActivityId: number | undefined
// {"format":"date-time","type":"string"}
    completionDate: string | undefined
// {"type":"string"}
    completionUser: string | undefined
// {"type":"boolean"}
    enableActivityPostProcessor: boolean | undefined
// {"format":"uuid","type":"string"}
    id: string | undefined
// {"type":"boolean"}
    isProcessDriven: boolean | undefined
// {"format":"date-time","type":"string"}
    slaExpiryDate: string | undefined
// {"format":"int32","type":"integer"}
    status: number | undefined
// {"format":"int32","type":"integer"}
    workTaskId: number | undefined
  }

  export class InfrastructureRepositoryBuilderResponse {
// {"type":"string"}
    fromVersion: string | undefined
// {"type":"string"}
    repositoryAlias: string | undefined
// {"type":"string"}
    repositoryName: string | undefined
// {"type":"string"}
    server: string | undefined
// {"type":"boolean"}
    success: boolean | undefined
// {"type":"string"}
    toVersion: string | undefined
  }

  export class PromotionTaxonomyCreatePackageRequest {
// {"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.PackageDescription"}
    description: any | undefined
// {"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.PackageScopeModel"}
    scope: any | undefined
// {"format":"uuid","type":"string"}
    tenantEnvironmentSolutionId: string | undefined
  }

  export class PromotionTaxonomyCreatePackageResponse {
// {"items":{"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.PromotionNotificationItem"},"type":"array"}
    notifications: PromotionTaxonomyPromotionNotificationItem[] | undefined ; 
// {"$ref":"#/definitions/e5.Domain.Models.Configuration.PromotionPackageModel"}
    package: any | undefined
// {"$ref":"#/definitions/e5.Domain.Models.Configuration.PromotionDefinitionModel"}
    promotion: any | undefined
  }

  export class PromotionTaxonomyCreateWorkflowPackageRequest {
// {"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.PromotionConflictResolutionModel"}
    conflictResolution: any | undefined
// {"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.PackageDescription"}
    description: any | undefined
// {"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.WorkflowScopeModel"}
    scope: any | undefined
  }

  export class PromotionTaxonomyPackageDescription {
// {"type":"string"}
    author: string | undefined
// {"type":"string"}
    description: string | undefined
// {"type":"string"}
    fileName: string | undefined
// {"type":"string"}
    label: string | undefined
// {"type":"string"}
    packageId: string | undefined
// {"type":"string"}
    version: string | undefined
  }

  export class PromotionTaxonomyPackageScopeModel {
// {"items":{"$ref":"#/definitions/e5.Promotion.Taxonomy.Domain.PromotionCategory1Model"},"type":"array"}
    category1: PromotionTaxonomyPromotionCategory1Model[] | undefined ; 
// {"format":"date-time","type":"string"}
    modifiedAfterDateTime: string | undefined
// {"type":"string"}
    modifiedUserName: string | undefined
// {"enum":["All","TaxonomyOnly","WorkfklowOnly"],"type":"string"}
    scopeByArea: string | undefined
// {"enum":["AllPublishedVersions","LatestPublishedVersionOnly"],"type":"string"}
    workflowScope: string | undefined
  }

  export class PromotionTaxonomyPromotionCategory1Model {
// {"format":"uuid","type":"string"}
    id: string | undefined
  }

  export class PromotionTaxonomyPromotionConflictResolutionModel {
// {"enum":["Discard","Fail","OverWrite"],"type":"string"}
    recordExists: string | undefined
  }

  export class PromotionTaxonomyPromotionNotificationItem {
// {"type":"string"}
    description: string | undefined
// {"enum":["Error","Info","Warning"],"type":"string"}
    severity: string | undefined
  }

  export class PromotionTaxonomyWorkflowScopeModel {
// {"format":"uuid","type":"string"}
    workflowId: string | undefined
// {"enum":["AllPublishedVersions","LatestPublishedVersionOnly"],"type":"string"}
    workflowScope: string | undefined
// {"format":"uuid","type":"string"}
    workflowVersionId: string | undefined
  }

  export class UIDocumentsModel {
// {"additionalProperties":{"type":"object"},"type":"object"}
    fields: any | undefined
// {"format":"int32","type":"integer"}
    sortOrder: number | undefined
  }

  export class UIFieldSetModel {
// {"format":"int32","type":"integer"}
    fieldSetId: number | undefined
// {"type":"string"}
    fieldSetType: string | undefined
// {"items":{"$ref":"#/definitions/e5.UI.Models.UIWorkFieldModel"},"type":"array"}
    fields: UIWorkFieldModel[] | undefined ; 
  }

  export class UIListModel {
// {"type":"string"}
    code: string | undefined
// {"format":"int32","type":"integer"}
    id: number | undefined
// {"type":"string"}
    label: string | undefined
  }

  export class UIMenuModel {
// {"type":"string"}
    code: string | undefined
// {"type":"boolean"}
    enabled: boolean | undefined
// {"type":"string"}
    label: string | undefined
  }

  export class UIPropertyModel {
// {"type":"string"}
    defaultValue: string | undefined
// {"format":"int32","type":"integer"}
    fieldDataType: number | undefined
// {"type":"string"}
    label: string | undefined
// {"format":"int32","type":"integer"}
    listId: number | undefined
// {"format":"int32","type":"integer"}
    parentListId: number | undefined
// {"type":"string"}
    parentPropertyId: string | undefined
// {"type":"string"}
    pattern: string | undefined
// {"type":"string"}
    placeholder: string | undefined
// {"type":"string"}
    propertyId: string | undefined
// {"type":"object"}
    resolvedValue: any | undefined
// {"type":"object"}
    value: any | undefined
  }

  export class UISearchDefinitionModel {
// {"items":{"$ref":"#/definitions/e5.UI.Models.UIFieldSetModel"},"type":"array"}
    fieldsets: UIFieldSetModel[] | undefined ; 
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    pageSize: number | undefined
// {"items":{"$ref":"#/definitions/e5.UI.Models.UIPropertyModel"},"type":"array"}
    properties: UIPropertyModel[] | undefined ; 
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
// {"items":{"$ref":"#/definitions/e5.UI.Models.UISearchFieldModel"},"type":"array"}
    searchFields: UISearchFieldModel[] | undefined ; 
// {"format":"uuid","type":"string"}
    zoneTemplateId: string | undefined
// {"items":{"$ref":"#/definitions/e5.UI.Models.UISearchZoneModel"},"type":"array"}
    zones: UISearchZoneModel[] | undefined ; 
  }

  export class UISearchDefinitionRefModel {
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    searchDefinitionId: number | undefined
  }

  export class UISearchFieldModel {
// {"type":"string"}
    fieldDataType: string | undefined
// {"type":"string"}
    fieldDefinitionId: string | undefined
// {"format":"int32","type":"integer"}
    fieldDisplayOrder: number | undefined
// {"type":"string"}
    fieldLabel: string | undefined
// {"format":"int32","type":"integer"}
    fieldStatus: number | undefined
  }

  export class UISearchZoneModel {
// {"format":"int32","type":"integer"}
    contentTypeId: number | undefined
// {"format":"int32","type":"integer"}
    zoneSequence: number | undefined
  }

  export class UITabModel {
// {"items":{"format":"int32","type":"integer"},"type":"array"}
    fieldSetIds: number[] | undefined ; 
// {"type":"string"}
    name: string | undefined
// {"format":"int32","type":"integer"}
    tabId: number | undefined
  }

  export class UIWorkFieldModel {
// {"type":"string"}
    description: string | undefined
// {"type":"boolean"}
    inFindMode: boolean | undefined
// {"type":"boolean"}
    isReadOnly: boolean | undefined
// {"type":"boolean"}
    isRequired: boolean | undefined
// {"type":"string"}
    propertyId: string | undefined
  }

  export class UIWorkItemModel {
// {"items":{"$ref":"#/definitions/e5.UI.Models.UIFieldSetModel"},"type":"array"}
    fieldsets: UIFieldSetModel[] | undefined ; 
// {"items":{"$ref":"#/definitions/e5.UI.Models.UIMenuModel"},"type":"array"}
    menus: UIMenuModel[] | undefined ; 
// {"items":{"$ref":"#/definitions/e5.UI.Models.UIPropertyModel"},"type":"array"}
    properties: UIPropertyModel[] | undefined ; 
// {"items":{"$ref":"#/definitions/e5.UI.Models.UITabModel"},"type":"array"}
    tabs: UITabModel[] | undefined ; 
// {"format":"uuid","type":"string"}
    workId: string | undefined
  }
